var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"multicolor-icon"},[_c('div',[_c('i',{staticClass:"fa",class:[_vm.iconClass, _vm.rightClass],style:(_vm.rightStyle)})]),_c('div',[_c('i',{staticClass:"fa",class:[_vm.iconClass, _vm.leftClass],style:(_vm.leftStyle)})])])}
var staticRenderFns = []

export { render, staticRenderFns }